import React, { useEffect, useState } from 'react'
import { StepProps } from '../Popup'
import { getPrice } from '../../service/calendar'
import { Elements } from '@stripe/react-stripe-js'
import { GuestData } from '../../service/cart'
import { Stripe, loadStripe } from '@stripe/stripe-js'
import { placeOrder } from '../../service/cart'
import Config from '../../util/config'
import Loader from '../Loader'
import OrderForm from './OrderForm'
import useGetDataFromSupercontrol from '../hooks/useGetDataFromSupercontrol'
import { dispatchEvent } from '../../util/dispatch-event'
import dayjs from 'dayjs'

let stripePromise: Promise<Stripe> = null

const Step2: React.FunctionComponent<StepProps<any, any>> = (props) => {
  const { data, setLargePopup, setData } = props
  const [ clientSecret, setClientSecret ] = useState<string>(null)
  const [ intentId, setIntentId ] = useState<string>(null)
  const [ resetVoucherValue, setResetVoucherValue ] = useState<boolean>(false)
  const [ error, setError ] = useState<string>(null)
  const [ displayEnquiry, setDisplayEnquiry ] = useState<boolean>(false)
  const [ sentFormOpen, setSentFormOpen ] = useState<boolean>(false)
  const [ guests, setGuests ] = useState<GuestData>({
    adults: 2,
    children: 0,
    infants: 0
  })
  const [ bookingData, setBookingData ] = useState<any>({})
  const [ extraData, setExtraData ] = useState<any>([])
  const [ priceHistory, setPriceHistory ] = useState<number[]>([])

  const options = {
    clientSecret: clientSecret,
  }

  const {
    apiResponse,
    loading,
    setLoading,
    fetchData
  } = useGetDataFromSupercontrol(
    data,
    setData,
    setError,
    (msg, data) => {
      setResetVoucherValue(!resetVoucherValue)
      setError(msg)
      delete data.voucher

      return data
    },
    () => setError(null),
    true
  )

  useEffect(() => {
    if (!apiResponse)
      return

    
    const arrival = dayjs(
      apiResponse.cart.properties[0].arrival.date,
      'YYYY-MM-DD'
    )
    const departure = dayjs(
      apiResponse.cart.properties[0].departure.date,
      'YYYY-MM-DD'
    )

    getPrice(
      arrival,
      Math.abs(arrival.diff(departure, 'day'))
    ).then(response => {
      if (response.enquiry)
        setDisplayEnquiry(true)
    })
  }, [ apiResponse ])

  useEffect(() => {
    setLargePopup(true)
    stripePromise = loadStripe(Config.get('paymentKey'))
  }, [])

  useEffect(() => {
    const popupClosed = () => {
      dispatchEvent(document, 'gloversure.payment.form.close', {
        property_code: data.properties[0].cottage_id,
        arrival: data.properties[0].arrival.date,
        departure: data.properties[0].departure.date,
        property_name: apiResponse.cart.properties[0].name,
        price: apiResponse.cart.properties[0].price.total_final,
        currency: apiResponse.cart.currency,
      })
    }

    document.addEventListener('gloversure.payment.popup.close', popupClosed)
    return () => {
        document.removeEventListener('gloversure.payment.popup.close', popupClosed)
    }
  }, [ apiResponse ]);

  useEffect(() => {
    if (apiResponse === null || sentFormOpen || apiResponse?.cart?.properties[0]?.price?.total_final === null)
      return

    dispatchEvent(document, 'gloversure.payment.form.open', {
      property_code: data.properties[0].cottage_id,
      arrival: data.properties[0].arrival.date,
      departure: data.properties[0].departure.date,
      property_name: apiResponse.cart.properties[0].name,
      price: apiResponse.cart.properties[0].price.total_final,
      currency: apiResponse.cart.currency,
    })

    setSentFormOpen(true)
  }, [ apiResponse ])

  useEffect(() => {
    setClientSecret(null)
    setIntentId(null)
    if (apiResponse && apiResponse.cart && apiResponse.cart.price) {
      if (apiResponse.cart.price.total_final === 0) {
        // Supercontrol indicate a enquiry property via a final price of 0
        setDisplayEnquiry(true)
      } else {
        placeOrder(apiResponse, intentId).then(res => {
          setClientSecret(res.clientSecret)
          setIntentId(res.intentId)

          if (apiResponse) {
            const tmp = [ ...priceHistory ]
            tmp.push(apiResponse.cart.price.total_final)
            setPriceHistory(tmp)
          }
        })
      }
    }

    if (apiResponse && apiResponse.cart?.properties[0]?.extras) {
      setExtraData([ ...apiResponse.cart.properties[0].extras ])
    }
  }, [ apiResponse ])

  if (displayEnquiry) {
    const property = apiResponse.cart.properties[0]
    const queryString: string[] = [
      `property_name=${property.name}`,
      `startdate=${property.arrival.date}`,
      `enddate=${property.departure.date}`,
      'fromcheckout=true',
    ]
    return <div className="send--enquiry">
      <p>The selected dates are available but can't be booked online. Get in touch to book here.</p>
      <a
        className="button--primary checkout_btn"
        href={(window as any).siteInfo.url + '/contact?' + queryString.join('&')}
      >Send Enquiry</a>
    </div>
  }

  if (clientSecret === null || stripePromise === null || loading)
    return <Loader />

  return <Elements stripe={stripePromise} options={options}>
    <OrderForm
      data={data}
      setData={setData}
      apiResponse={apiResponse}
      fetchData={fetchData}
      setError={setError}
      setLoading={setLoading}
      error={error}
      resetVoucherValue={resetVoucherValue}
      id={clientSecret}
      intentId={intentId}
      guests={guests}
      setGuests={setGuests}
      bookingData={bookingData}
      setBookingData={setBookingData}
      originalAmount={priceHistory[0] || apiResponse.cart.price.total_final}
      extraData={[ ...extraData ]}
      setExtraData={setExtraData}
    />
  </Elements>
}

export default Step2

